import {Nominal, nominate} from "platformed-client/types";

/**
 * A filter key uniquely identifies a filter in the list of filters. It's not
 * enough to use the filter kind, because there can be multiple filters of the
 * same kind.
 */

export type FilterKey = Nominal<string, "filterKey">;

export function generateFilterKey(): FilterKey {
  return nominate("filterKey", window.crypto.randomUUID());
}
